import { useState } from 'react';

export function useCalendarUI() {
    const [selectedDay, setSelectedDay] = useState<Date | null>(null);
    const [isDayPopupOpen, setIsDayPopupOpen] = useState(false);
    const [popupPosition, setPopupPosition] = useState<{ x: number; y: number } | undefined>(undefined);
    const [isBlockTimeModalOpen, setIsBlockTimeModalOpen] = useState(false);

    const handleSelectEvent = (_event: unknown, e: React.SyntheticEvent<HTMLElement>) => {
        const rect = (e.target as HTMLElement).getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top;

        setPopupPosition({ x, y });

        const event = _event as { start: Date };
        const eventDate = new Date(event.start);
        setSelectedDay(eventDate);
        setIsDayPopupOpen(true);
    };

    const handleSelectSlot = (slotInfo: {
        start: Date;
        box?: { x: number; y: number; clientX: number; clientY: number };
    }) => {
        if (slotInfo.box) {
            setPopupPosition({ x: slotInfo.box.clientX, y: slotInfo.box.clientY });
        } else {
            // Fallback for mobile touch events where box might not be provided
            setPopupPosition({ x: window.innerWidth / 2, y: 100 });
        }

        setSelectedDay(slotInfo.start);
        setIsDayPopupOpen(true);
    };

    const closeDayPopup = () => {
        setIsDayPopupOpen(false);
        setSelectedDay(null);
        setPopupPosition(undefined);
    };

    const openBlockTimeModal = () => {
        setIsDayPopupOpen(false); // Close the day popup first
        setIsBlockTimeModalOpen(true); // Then open the modal
    };

    const closeBlockTimeModal = () => {
        setIsBlockTimeModalOpen(false);
    };

    return {
        selectedDay,
        isDayPopupOpen,
        popupPosition,
        isBlockTimeModalOpen,
        handleSelectEvent,
        handleSelectSlot,
        closeDayPopup,
        openBlockTimeModal,
        closeBlockTimeModal,
    };
}
